import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import actions from '../state/actions';
import { localize } from '../i18n';

const refreshTime = 1000 * 60; // 1 minute

class Refresh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'reset',
      timedRefresh: setInterval(() => {
        props.onRefresh(false);
      }, refreshTime),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.status === 'refreshing' && nextProps.refresh.completed === true) {
      const newState = {
        status: 'reset',
      };
      this.setState(Object.assign({}, this.state, newState));
    }
  }

  componentWillUnmount() {
    // Clear timed refresh
    window.clearInterval(this.state.timedRefresh);
  }

  render() {
    const icon = (
      <i className="md-icon material-icons">&#xE5D5;</i>
    );

    // const newServiceRequests = this.props.newServiceRequests;

    return (
      <span>
        <a
          href="#refresh"
          title={this.props.t('Refresh')}
          onClick={() => {
            this.setState({
              status: 'refreshing',
            });
            this.props.onRefresh(true);
          }}
          className="Refresh"
        >
          {icon}
        </a>
      </span>
    );
  }
}

Refresh.propTypes = {
  // eslint-disable-next-line
  refresh: PropTypes.shape({
    refreshing: PropTypes.bool,
    completed: PropTypes.bool,
  }),
  // newServiceRequests: React.PropTypes.arrayOf(React.PropTypes.object),
  onRefresh: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const refresh = state.refresh;
  // const newServiceRequests = state.ticket.newServiceRequests;
  return {
    refresh,
    // newServiceRequests,
  };
};

const mapDispatchToProps = dispatch => ({
  onRefresh(isManual) {
    dispatch(actions.refreshAction(isManual));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(Refresh));



// WEBPACK FOOTER //
// ./src/containers/Refresh.js